export default __webpack_public_path__ + "static/media/transportation.e585231f.png";